<template>
    <v-dialog v-model="qrcodeOptions.showPopup" fullscreen style="position: relative; z-index: 9999999">
        <v-card color="grey lighten-2">

            <!--Title-->
			<div class="grey darken-3 white--text noprint">
				Location {{ qrcodeOptions.locationName }} QR CODE
			</div>

			<!--
			Printable QR Code
			  Renders a printable poster containing company information and the QR code
			-->
			<div id="qrcard" class="d-flex flex-column align-center text-center">
                <v-card height=100% style="width: 100% !important" color="secondary" rounded=0 class=" align-center">
				    <!--Company logo-->
				    <v-img :src="require('@/assets/tfw_logo.png')" contain width="100%" max-height="128" class="mt-4 mb-4 mx-auto"/>
                </v-card>

				<!--Instruction-->
				<p class="text-h4 primary white--text font-weight-bold py-4" style="width: 100%">SWAPP In/Out</p>

				<!--QR Code-->
				<v-card-text class="text-center" id="downloadCode">
					<qrcode-vue :value="qrcodeOptions.value"
								:size="qrcodeOptions.size"
								:level="qrcodeOptions.level"
								:id="qrcodeOptions.id"
								:renderAs="qrcodeOptions.renderAs"
								:background="qrcodeOptions.background"
								:foreground="qrcodeOptions.foreground">
					</qrcode-vue>
				</v-card-text>

				<!--Site name-->
				<!-- <p class="text-h4 font-weight-bold">{{ qrcodeOptions.siteName }}</p> -->

				<!--Location name-->
				<p class="text-h4 font-weight-bold">{{ qrcodeOptions.locationName }}</p>

				<!--Site telephone number-->
				<p class="text-h5 darkgrey--text">{{ qrcodeOptions.siteTelephone }}</p>

				<!--Portal domain-->
				<p>To SWAPP In / Out download the App from</p>
				<p class="text-h5 font-weight-bold primary--text">tfw.swapp.work</p>

				<!--Vindico branding-->
				<v-img :src="require('@/assets/vlogo.png')" width="128"/>
				<p class="mt-1 grey--text">Created by Vindico</p>
			</div>

			<!-- <v-divider/> -->

			<v-card-actions class="text-right noprint">
				<!-- <v-tooltip color="primary" bottom>
				  <template v-slot:activator="{ on }">
					<v-btn height="40" min-width="40" width="40" class="primary mr-1 mb-4 inputradius" @click.stop="downloadWithVueResource" v-on="on">
					  <v-icon>icons8-download</v-icon>
					</v-btn>
				  </template>
				  <span class="tableBackground--text">Download QR code</span>
				</v-tooltip> -->
				<v-spacer/>
				<v-btn color="grey lighten-1" @click="closeQrCode()">Close</v-btn>
				<v-btn color="black white--text" @click="exportCode()">Print</v-btn>
			</v-card-actions>
        </v-card>
    </v-dialog>
</template>


<script>
import QrcodeVue from "qrcode.vue";
import * as htmlToImage from "html-to-image";
import { saveAs } from "file-saver";
import { mapState } from "vuex";

export default {
    name: 'QrCodeGenerator',
    components: {
        QrcodeVue
    },
    computed: {
        ...mapState('qr_code_generator_store/', {
            qrcodeOptions: state => state.qrcode_generator,
        })
    },
    methods: {
        closeQrCode() {
            this.MIX_generateCode(false, '', 300, "H", "qrcode", "canvas", "#ffffff", "#000000", false, '', ''); 
        },
        exportCode() {
            window.print();
         },
        downloadWithVueResource() {
            htmlToImage.toBlob(document.getElementById("downloadCode")).then(function(blob) {
                window.saveAs(blob, "QRcode.png");
            });
        },
    }
}
</script>

<style>
@media print {
  .noprint {
    display: none !important;
    clear: both !important;
  }
  .qrcard {
    width: 90vh !important;
    height: 90vh !important;
  }
}
</style>